import { FC, useState } from "react";
import Page from "../../components/page/page";
import { InventoryTable } from "./inventory/inventory-table";
import { InventoryDialog } from "./inventory/intentory-dialog";

export const Inventory: FC = () => {
  const [showAddInventory, setShowInventory] = useState(false)

  return (
    <Page title="Inventory Manager">
      <div className="w-full">
        <div className="full h-full flex flex-col px-6">
          <InventoryTable />
        </div>
      </div>
      <InventoryDialog
        isShowing={showAddInventory}
        close={() => { setShowInventory(false) }}
      />
    </Page>
  )
}
